import React from 'react';
import Icon from 'components/icon/Icon';

export default class SortBy extends React.Component {
    // Validate data from props
    static propTypes = {
        items: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
        currentSort: React.PropTypes.object,
        updateSort: React.PropTypes.func.isRequired
    };

    handleSortByChange = (e) => {
        this.props.updateSort.call(this, (e.target.value ? JSON.parse(e.target.value) : null));
    }

    render() {
        return (
            <div className="sort-by">
                <div className="select-wrapper">
                    <select className="course-results-filter-sort-by" value={this.props.currentSort ? JSON.stringify(this.props.currentSort) : ''} onChange={this.handleSortByChange}>
                        <option value="">Sort By</option>
                        {this.props.items.map((sort, index) => {
                            return(
                                <option key={index} value={JSON.stringify(sort)}>{sort.label}</option>
                            );
                        })}
                    </select>
                    <Icon glyph = 'chevron-down' />
                </div>
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/filtered-listing/items/sort-by/SortBy.jsx
 **/